<template>
	<v-container>
		<div class="sortition-name text-center text-yellow">
			{{ result.sortition.name }}
		</div>
		<div class="sortition-date text-center text-yellow">{{ result.date }}</div>
		<v-row no-gutters>
			<v-col cols="6">
				<template v-if='result.first || result.second || result.third'>
					<v-row class="flex-column first-number" justify='center' align="center" no-gutters>
						<div class='d-flex font-weight-bold text-uppercase text-h6'>1st</div>
						<digit-image-display class='d-flex' :digit='result.first' :image-dimensions='digitsImageDimensions'/>
					</v-row>
					<v-row class="flex-column second-number" justify='center' align="center" no-gutters>
						<div class='d-flex font-weight-bold text-uppercase text-h6'>2nd</div>
						<digit-image-display class='d-flex' :digit='result.second' :image-dimensions='digitsImageDimensions'/>
					</v-row>
					<v-row class="flex-column third-number" justify='center' align="center" no-gutters>
						<div class='d-flex font-weight-bold text-uppercase text-h6'>3rd</div>
						<digit-image-display class='d-flex' :digit='result.third' :image-dimensions='digitsImageDimensions'/>
					</v-row>
				</template>
			</v-col>
			<v-col cols="6" class="flex-column justify-center">
				<v-row v-if='result.pickOne' justify='center' no-gutters>
					<v-col cols='12'>
						<span class='font-weight-bold text-uppercase text-h6'>PICK 1</span>
					</v-col>
					<v-col cols='auto'>
						<digit-image-display :digit='result.pickOne' :image-dimensions='digitsImageDimensions'/>
					</v-col>
				</v-row>
				<v-row v-if='result.pickTwo' justify='center' no-gutters>
					<v-col cols='12'>
						<span class='font-weight-bold text-uppercase text-h6'>PICK 2</span>
					</v-col>
					<v-col cols='auto'>
						<digit-image-display :digit='result.pickTwo' :image-dimensions='digitsImageDimensions'/>
					</v-col>
				</v-row>
				<v-row v-if='result.cashThree' justify='center' no-gutters>
					<v-col cols='12' class="d-flex justify-center">
						<v-img v-if='pickThreeImage' v-bind="pickThreeImage"></v-img>
						<span v-else class='font-weight-bold text-uppercase text-h6'>PICK 3</span>
					</v-col>
					<v-col cols='auto'>
						<digit-image-display class='d-flex' :digit='result.cashThree' :image-dimensions='digitsImageDimensions'/>
					</v-col>
				</v-row>
				<v-row v-if='result.pickFour' justify='center' no-gutters>
					<v-img v-if='pickFourImage' class="d-flex" v-bind="pickFourImage"></v-img>
					<div v-else class='d-flex font-weight-bold text-uppercase text-h6'>PICK 4</div>
					<div class="d-flex justify-center">
						<digit-image-display class='d-flex' horizontal :digit='result.pickFour' :image-dimensions='digitsImageDimensions'/>
					</div>
				</v-row>
				<v-row v-if='result.pickFive' justify='center' no-gutters>
					<v-img v-if='pickFiveImage' class="d-flex" v-bind="pickFiveImage"></v-img>
					<div v-else class='d-flex font-weight-bold text-uppercase text-h6'>PICK 5</div>
					<div class="d-flex justify-center">
						<digit-image-display class='d-flex' horizontal :digit='result.pickFive' :image-dimensions='digitsImageDimensions'/>
					</div>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import DigitImageDisplay from '@/homepage/components/DigitImageDisplay.vue';

export default {
	name: 'GenericResultDisplay',
	props: {
		result: {
			type: Object,
			required: true
		},
		digitsImageDimensions: {
			type: Object,
			required: false,
			default: () => ({
				height: 37,
				width: 37
			})
		},
		pickOneImage: {
			type: Object,
			required: false,
			default: null
		},
		pickTwoImage: {
			type: Object,
			required: false,
			default: null
		},
		pickThreeImage: {
			type: Object,
			required: false,
			default: null
		},
		pickFourImage: {
			type: Object,
			required: false,
			default: null
		},
		pickFiveImage: {
			type: Object,
			required: false,
			default: null
		}
	},
	components: {
		DigitImageDisplay
	}
};
</script>

<style>
</style>
